import { gql } from '@apollo/client';

export const QUERY_PICKUP_DRIVER_TRACKING_SNAPSHOT = gql`
    query QueryPickupDriverTrackingSnapshot($hubId: Long!, $taskDate: String, $asOfMs: Long) {
        pickupDriverTrackingSnapshot(hubId: $hubId, taskDate: $taskDate, asOfMs: $asOfMs) {
            hubId
            hubLatitude
            hubLongitude
            calcSlot
            calculatedAtMs
            longStayThresholdMin
            drivers {
                driverAccountId
                driverCode
                driverName
                driverPhone
                vehicleCategory
                anomalies
                startTimeMs
                handoverTimeMs
                stops {
                    siteId
                    siteName
                    address
                    status
                    stayMinutes
                    operatedAtMs
                    expectWindowStartMs
                    expectWindowEndMs
                    latitude
                    longitude
                }
            }
        }
    }
`;

/** KPI 单独查、单独按 10 分钟轮询（数仓 2.2，同派送大屏 KPI 与司机分开查） */
export const QUERY_PICKUP_DRIVER_TRACKING_KPI = gql`
    query QueryPickupDriverTrackingKpi($hubId: Long!, $taskDate: String, $asOfMs: Long) {
        pickupDriverTrackingKpi(hubId: $hubId, taskDate: $taskDate, asOfMs: $asOfMs) {
            current {
                calcSlot
                appointments
                pickedUp
                drivers
                failed
            }
            previous {
                calcSlot
                appointments
                pickedUp
                drivers
                failed
            }
            yesterday {
                calcSlot
                appointments
                pickedUp
                drivers
                failed
            }
        }
    }
`;

export const QUERY_PICKUP_DRIVER_TRACKING_POSITIONS = gql`
    query QueryPickupDriverTrackingPositions($hubId: Long!, $taskDate: String, $asOfMs: Long) {
        pickupDriverTrackingPositions(hubId: $hubId, taskDate: $taskDate, asOfMs: $asOfMs) {
            driverAccountId
            latitude
            longitude
            bearing
            locationTimestampMs
            track {
                latitude
                longitude
                bearing
                locationTimestampMs
            }
        }
    }
`;

// 首屏查一整天：单独一份文档，滚动发布期间后端还没有 fullDay 参数时只有首屏报错，不影响 20s 轮询
export const QUERY_PICKUP_DRIVER_TRACKING_POSITIONS_FULL_DAY = gql`
    query QueryPickupDriverTrackingPositionsFullDay($hubId: Long!, $taskDate: String, $asOfMs: Long) {
        pickupDriverTrackingPositions(hubId: $hubId, taskDate: $taskDate, asOfMs: $asOfMs, fullDay: true) {
            driverAccountId
            latitude
            longitude
            bearing
            locationTimestampMs
            track {
                latitude
                longitude
                bearing
                locationTimestampMs
            }
        }
    }
`;

export const QUERY_PICKUP_DRIVER_TRACKING_TRAJECTORY = gql`
    query QueryPickupDriverTrackingTrajectory(
        $hubId: Long!, $driverAccountId: Long!, $taskDate: String, $asOfMs: Long
    ) {
        pickupDriverTrackingTrajectory(
            hubId: $hubId, driverAccountId: $driverAccountId, taskDate: $taskDate, asOfMs: $asOfMs
        ) {
            latitude
            longitude
            bearing
            locationTimestampMs
        }
    }
`;
